import { render } from "./IconBezierCurve.vue?vue&type=template&id=5605bf49"
const script = {}

import exportComponent from "/home/beta/domains/architect-beta.youniversity.be/public_html/architect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__